module.exports = __webpack_public_path__ + "static/media/27.4df605af.jpg";